export interface PremiumUserFeedbackPayload {
    id: number
    user_id: number
    training_program_execution_id: number
    comment: string | null
    created_at: string
    training_program_id: number | null
    training_program_name: any | null
}

export class PremiumUserFeedback {
    id: number
    userId: number
    trainingProgramExecutionId: number
    comment: string | null
    createdAt: string
    trainingProgramId: number | null
    trainingProgramName: string | null

    constructor(data: PremiumUserFeedbackPayload) {
        this.fill(data)
    }

    fill(data: PremiumUserFeedbackPayload): this {
        this.id = data.id
        this.userId = data.user_id
        this.trainingProgramExecutionId = data.training_program_execution_id
        this.comment = data.comment
        this.createdAt = data.created_at
        this.trainingProgramId = data.training_program_id
        this.trainingProgramName = data.training_program_name
            ? (typeof data.training_program_name === 'object'
                ? Object.values(data.training_program_name)[0] as string
                : data.training_program_name)
            : null
        return this
    }

    exists(): boolean {
        return !!this.id
    }

    unset(): this {
        return this.fill(<any>{})
    }
}
